// ══════════════════════════════════════════════════════════════════
// useOdlozene — zoznam_plynuly_v1 (Mirko 13. 10. 2026: „pri posuvani sipkou lavy stlpec
// aj pravy strasne seká - opraviť.")
//
// PRECO: v master-detail zoznamoch menil kazdy krok kurzora selectedId, a na nom visel
// CELY pravy detail. Pri drzani sipky sa tak pri kazdom riadku prekreslila nielen polozka
// zoznamu, ale aj karta so vsetkym, co v nej je — v Cenovych ponukach 116 zaznamov,
// v Zamestnancoch 92. Vysledok bolo trhanie.
//
// AKO: zvyraznenie riadku ostava OKAMZITE (dalej cita selectedId), detail dostane hodnotu
// az ked sa kurzor na chvilu zastavi. Pri klikani myskou je 120 ms nebadatelnych, pri
// drzanej sipke sa detail nekresli vobec, kym clovek neprestane.
// ══════════════════════════════════════════════════════════════════
import { useState, useEffect } from 'react'

export default function useOdlozene(hodnota, ms = 120) {
  const [odlozena, setOdlozena] = useState(hodnota)
  useEffect(() => {
    const t = setTimeout(() => setOdlozena(hodnota), ms)
    return () => clearTimeout(t)
  }, [hodnota, ms])
  return odlozena
}
